<div class="generic-modal-root">
    <ngx-loading [show]="loading"></ngx-loading>
  
    <div class="row-padding">
      <div class="row">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Title </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="name"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Artist </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="artist"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Album </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="album"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Format </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="container"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Codec </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="codec"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Duration </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="duration"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Bit Depth </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="bitDepth"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Sample Rate </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="sampleRate"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Lossless </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="lossless"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Number of Channels </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="numberOfChannels"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Track gain (dB) </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="trackGain"
              />
            </div>
          </div>
  
          <div style="height: 45px;">
            <span style="color:red" *ngIf="form.invalid && form.dirty" class="m-form__help" >
              A track file, track name, artist, and !VALID! light show JSON are required
            </span><br>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  